import {useState} from "react";
import styled from "styled-components";
import Button from "../Shared/Button";
import Table from "../Shared/Table";
import {UseAppSelector} from "../../redux/configure-store";
import {
    getIsAllowBeneficiaryUpdates,
    getIsBeneficiaryArray, getIsPlanNonQualified, getIsPlanProfileOlaMessageData,
    getMcCAmishSwitch, getReceivedPlansData, getSelectedPlan, getTracPlan
} from "../../redux/profile/selectors";
import { getWebDomain, isInternal} from "../../utils/api";
import useLocalizePhrase from "../../utils/useLocalizePhrase";

const StyledBeneInfo = styled.div`
  margin-top: 24px;
  padding: 32px 40px;
  background-color: #fff;
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const StyledHeader = styled.div`
  border-bottom: 1px solid #bec3c8;
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  padding-bottom: 7px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const StyledLinkButton = styled.div`
  margin-right: 16px;
  @media (max-width: 640px) {
    margin-right: 0;
  }
`;

const StyledBeneContent = styled.div`
  font-size: 18px;
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;
const StyledDisclaimerContainer = styled.div`
  margin-bottom: 16px;
  padding: 32px 24px;
  border-radius: 4px;
  border: solid 1px #ffad00;
  background-color: rgba(255, 173, 0, 0.16);
  font-family: "Nimbus Sans Novus Regular"";
  line-height: 1.2;
  letter-spacing: 0.02px;
  color: #3b4b59;
`;

const StyledDisclaimerHeader = styled.div`
  font-size: 20px;
   font-family: "Nimbus Sans Novus Bold";
  text-align: left;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledDisclaimerSubHeader = styled.div`
  font-size: 18px;
   font-family: "Nimbus Sans Novus Bold";
  text-align: left;
  margin-top: 8px;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const StyledDisclaimerContent = styled.span`
  font-size: 18px;
  font-family: "Nimbus Sans Novus";
  font-weight: normal;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const BeneficiaryCard = () => {
    const [ showMore, setShowMore] = useState(false);
    const selectedPlan = UseAppSelector(getSelectedPlan);
    const plansData = UseAppSelector(getReceivedPlansData);
    const isAllowBeneficiaryUpdates = UseAppSelector(getIsAllowBeneficiaryUpdates);
    const onPremBene = UseAppSelector(getIsPlanProfileOlaMessageData);
    const isOnPremBene = onPremBene && onPremBene.toLowerCase() === 'y';
    const planNumber = selectedPlan.value;
    const recordKeeper = plansData?.find((plan: any) => plan.planNumber === planNumber)?.recordKeeper;
    const isBeneficiaryArray = UseAppSelector(getIsBeneficiaryArray);
    const mcCAmishSwitchValue = UseAppSelector(getMcCAmishSwitch);
    const isMcCAmishSwitch = mcCAmishSwitchValue === "Y";
    const isPlanNonQualified = UseAppSelector(getIsPlanNonQualified);
    const isTracPlan = UseAppSelector(getTracPlan);
    const isOmniPlan = !isPlanNonQualified && !isTracPlan;
    const noticePlanNumbers = ["104867", "106282","106283"];
    const showNotice = noticePlanNumbers.includes(planNumber);
    const headerNames = ["TYPE", "NAME", "DISTRIBUTION %"];
    const noBeneficiaryHeaderNames = ["TYPE", "STATUS", "ACTION"];
    const myBeneficiariesTitle = useLocalizePhrase('My Beneficiaries');
    const offTitle = useLocalizePhrase('Off');
    const signUpTitle = useLocalizePhrase('Sign Up');
    const beneficiaryInformationTitle = useLocalizePhrase('Beneficiary Information');
    const noticeTitle = useLocalizePhrase('Notice');
    const ifYouAreMarriedTitle = useLocalizePhrase('If you are married');
    const ifYouAreSingle = useLocalizePhrase('If you are single');

    const noBeneficiaryTableColumnData = [
        [
            {name:"type",  value: "My Beneficiaries"},
            {name:"status", value: "Off"},
            {name:"action", value: "Sign Up"},
        ]

    ];

    const secondaryArray =  isBeneficiaryArray.filter(record =>record.level === "SECONDARY");
    const primaryArray =  isBeneficiaryArray.filter(record =>record.level === "PRIMARY");
    const isPendingBeneficiaryExists = !!isBeneficiaryArray.find(record => record.status === "PENDING");
    let beneTableDataArray = isBeneficiaryArray.filter(record => record.level !== 'TERTIARY').map(record =>  [
        {name:"type", value: record.level.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase())},
        {name: "name", value: record.name ? record.name.replace(",","").toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase()) : record.name.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase())},
        {name: "distribution", value: record.disbursement}
    ]
    )
    const isShowLessEligible =  (secondaryArray.length > 0 || beneTableDataArray.length > 2);

    const hasOnlyPrimary = (primaryArray.length === 1 || primaryArray.length === 2) && secondaryArray.length === 0;

    const beneTableData =  (!showMore && !hasOnlyPrimary && isShowLessEligible)? beneTableDataArray.slice(0,Math.min(2,primaryArray.length)): beneTableDataArray;

    const isMcCAmishPlan = isPlanNonQualified && !isMcCAmishSwitch && recordKeeper === "rec_keeper_mcc";

    const nonQualUrl = `/rps/rws/account/participant/account-sso/page-redirect.otc?launchPage=PROFILE&launchModule=&targetPage=SSO&targetModule=&targetStep=&param1=beneficiary&param2=mccamish&param3=${planNumber}`;

    const omniUrl = "/rps/rws/account/participant/beneficiary-info.otc?accountKey=RPS_" + planNumber;

    const tracUrl = "/rps/rws/account/participant/trac-iframe-partic-beneficiaries.otc?fromParam=accounts";

    let buttonText = "";
    let isButtonDisable = true;
    let url = "";
    //This is for non-qual plan
    if (isPlanNonQualified) {
        buttonText = "View/Update Beneficiary";
        isButtonDisable = isInternal();
        url = nonQualUrl;
    }
    //This is for trac plan
    if (isTracPlan) {
        buttonText = "View Beneficiary";
        isButtonDisable = false;
        url = tracUrl;
    }
    //This is for Omni plan
    if (isOmniPlan) {
        buttonText = isAllowBeneficiaryUpdates ? "Update Beneficiary" : "View Beneficiary";
        url = omniUrl;
        isInternal()? isButtonDisable = !isOnPremBene : isButtonDisable = false;
    }
    const isSignupButtonDisable = isInternal() && !isOnPremBene;
    const goToNewPage = (url) => {
        console.log('url', url);
        document.location.href = getWebDomain() + url;
    }

    return (
        <StyledBeneInfo>
            <StyledHeader>
              {beneficiaryInformationTitle}
            </StyledHeader>


            {showNotice &&
                <StyledDisclaimerContainer>
                    <StyledDisclaimerHeader>
                      {noticeTitle}
                    </StyledDisclaimerHeader>
                    <StyledDisclaimerSubHeader>
                        {ifYouAreMarriedTitle}:&nbsp;
                        <StyledDisclaimerContent>
                            your spouse is your beneficiary, regardless of your designation below, unless your spouse agrees
                             in writing on a Savings Plan beneficiary form.
                        </StyledDisclaimerContent>
                    </StyledDisclaimerSubHeader>
                    <StyledDisclaimerSubHeader>
                        {ifYouAreSingle}:&nbsp;
                        <StyledDisclaimerContent>
                        you may name anyone as your beneficiary. If you are single and do not have a designation below,
                        benefits will be paid to your estate.
                        </StyledDisclaimerContent>
                    </StyledDisclaimerSubHeader>
                </StyledDisclaimerContainer>
            }
            <>
                {(isMcCAmishPlan || isTracPlan) ?
                        <StyledButtonContainer>
                            <Button
                                onBeaconClick={() => isMcCAmishPlan? goToNewPage(nonQualUrl) : isTracPlan ? goToNewPage(tracUrl) : goToNewPage(omniUrl) }
                                buttonTitle={isMcCAmishPlan ? "View/Update Beneficiary" : isTracPlan ? "View Beneficiary" : "Update Beneficiary"}
                                disabled={isInternal() && !!isMcCAmishPlan}
                            />
                        </StyledButtonContainer>
                     :
                    isPendingBeneficiaryExists ?
                        (
                            <>
                                <StyledBeneContent>
                                A beneficiary election change is pending. It will be effective only after we have
                                received the completed form with your signature and your spouse’s consent.
                            </StyledBeneContent>
                                <StyledButtonContainer>
                                    <Button
                                        onBeaconClick= {() => goToNewPage(omniUrl)}
                                        buttonTitle= "Update Beneficiary"/>
                                </StyledButtonContainer>
                            </>
                        )
                        :
                    <>
                        {(isBeneficiaryArray.length > 0) ?
                            <Table isBeneCard headerNames={headerNames} tableColumnData={beneTableData} borderless={true}/> :
                            <Table
                              isBeneCard
                              onlyMyBeneficiaries={true}
                              headerNames={noBeneficiaryHeaderNames}
                              tableColumnData={noBeneficiaryTableColumnData}
                              isSignupButtonDisable={isSignupButtonDisable}
                              borderless={true}
                            />
                        }

                        {isBeneficiaryArray.length > 0 &&
                            <StyledButtonContainer>
                                {!hasOnlyPrimary &&
                                    <StyledLinkButton>
                                        <Button variant="tertiary" isLink={true} buttonTitle={!showMore?"View All":"View Less"} onBeaconClick={()=>setShowMore(!showMore)}/>
                                    </StyledLinkButton>}
                                {isButtonDisable}
                                <Button buttonTitle={buttonText} disabled={isButtonDisable} onBeaconClick={() => goToNewPage(url)}/>
                            </StyledButtonContainer>
                        }
                    </>


                }
            </>
        </StyledBeneInfo>
    )
}
